import React, { useState } from "react";
import { useGlobalContext } from "./context/globalContext";

const Header = () => {
  const { handleShowModal } = useGlobalContext();
  const [mMenu, setMMenu] = useState(false);
  return (
    <header className="micro-nav fixed-top">
      <nav className="navbar navbar-expand-lg navbar-light bg-white micro-navbar housebrand-logo">
        <button
          className="navbar-toggler collapsed"
          onClick={() => setMMenu(!mMenu)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <a
          className="navbar-brand display-none-mobile"
          href="#home"
          style={{ cursor: "pointer" }}
        >
          <img
            src="images/logo.webp"
            className="logo"
            alt="Raymond's MIG Bandra"
          />
        </a>
        <a
          className="navbar-brand housebazaar-logo-brand"
          href="#home"
          style={{ cursor: "pointer" }}
        >
          <img
            src="images/logo.webp"
            className="Logo"
            alt="Raymond's MIG Bandra"
          />
        </a>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav nav-fill">
            <li className="nav-item">
              <a
                className="nav-link"
                href="#home"
                style={{ cursor: "pointer" }}
              >
                <i className="mi mi-home nav-icon"></i>
                <span className="d-sm-inline d-md-none"> Home</span>
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#pricing"
                style={{ cursor: "pointer" }}
              >
                <i className="mi mi-price nav-icon"></i> Price
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#floorplan"
                style={{ cursor: "pointer" }}
              >
                <i className="mi mi-siteplan nav-icon"></i> Site &amp; Floor
                Plan
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#Amenities"
                style={{ cursor: "pointer" }}
              >
                <i className="mi mi-ami nav-icon"></i> Amenities
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#Gallery"
                style={{ cursor: "pointer" }}
              >
                <i className="mi mi-gallery nav-icon"></i> Gallery
              </a>
            </li>

            <li className="nav-item overflow-hidden">
              <a
                onClick={() => {
                  setMMenu(false);
                  handleShowModal("Download Brochure");
                }}
                className="nav-link enqModal download_brochure"
                href="#broucher"
                style={{ cursor: "pointer" }}
              >
                <i className="mi mi-download nav-icon d-inline-block animated slideInDown infinite"></i>{" "}
                Download Brochure
              </a>
            </li>
          </ul>
        </div>
        {mMenu && (
          <div className="navbar-collapse">
            <ul className="navbar-nav nav-fill">
              <li className="nav-item">
                <a
                  onClick={() => setMMenu(false)}
                  className="nav-link"
                  href="#home"
                  style={{ cursor: "pointer" }}
                >
                  <i className="mi mi-home nav-icon"></i>
                  <span className="d-sm-inline d-md-none"> Home</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => setMMenu(false)}
                  className="nav-link"
                  href="#pricing"
                  style={{ cursor: "pointer" }}
                >
                  <i className="mi mi-price nav-icon"></i> Price
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => setMMenu(false)}
                  className="nav-link"
                  href="#floorplan"
                  style={{ cursor: "pointer" }}
                >
                  <i className="mi mi-siteplan nav-icon"></i> Site &amp; Floor
                  Plan
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => setMMenu(false)}
                  className="nav-link"
                  href="#Amenities"
                  style={{ cursor: "pointer" }}
                >
                  <i className="mi mi-ami nav-icon"></i> Amenities
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => setMMenu(false)}
                  className="nav-link"
                  href="#carousel"
                  style={{ cursor: "pointer" }}
                >
                  <i className="mi mi-gallery nav-icon"></i> Gallery
                </a>
              </li>

              <li className="nav-item overflow-hidden">
                <a
                  onClick={() => handleShowModal("Download Brochure")}
                  className="nav-link enqModal download_brochure"
                  href="#broucher"
                  style={{ cursor: "pointer" }}
                >
                  <i className="mi mi-download nav-icon d-inline-block animated slideInDown infinite"></i>{" "}
                  Download Brochure
                </a>
              </li>
              {/* <li className="nav-item">
                <a
                  onClick={() => setMMenu(false)}
                  className="nav-link"
                  href="#capitalacres"
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="images/Official Logo K-nine realtorss.jpg"
                    alt="Raymond's MIG Bandra"
                    className="logo navbar-brand display-none-mobile"
                    style={{ height: "40px" }}
                  />
                </a>
              </li> */}
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
